import message_vue_vue_type_script_setup_true_lang_default from "./message.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/message/src/message.vue
var message_default = message_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { message_default as default };
//# sourceMappingURL=message2.mjs.map